module.exports = __webpack_public_path__ + "img/ic_room_discount_right_img.1172bf8c.png";